import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from './components/Router';
import Theme from './components/Theme';
import LimitReachedHeader from './components/Layout/Header/LimitReachedHeader';

const App = (props) => {
	const { siteId, userBalance } = props;

	return (
		<Theme siteId={siteId}>
			{userBalance?.nextAvailablePurchaseDate || userBalance?.totalLeft <= 0 ? (
				<LimitReachedHeader userBalance={userBalance} />
			) : null}
			<Router siteId={siteId} />
		</Theme>
	);
};

App.propTypes = {
	siteId: PropTypes.number,
	userBalance: PropTypes.object
};

const mapStateToProps = (state) => {
	return {
		siteId: state.authSlice.siteId,
		userBalance: state.authSlice.userBalance.data
	};
};

export default connect(mapStateToProps, null)(App);
